import {h, Component} from 'preact';
import {connect} from 'preact-redux';
import style from './style.scss'
import SystemModel from '/chat/src/redux/model/system/model';

class HeaderTitle extends Component {
    render(){
        const title = this.props.title;
        const body = this.props.body;


        let defaultStyle = style.NormalHeader
        if(this.props.isMobile)  defaultStyle = style.MobileHeader

        return (
            <div className={defaultStyle}>
                <div className={style.Title}>{title} </div>
                <div className={style.Body}>{body}</div>
            </div>
        );
    }
}

export default connect((state) => {
    return {
        isMobile: SystemModel.isMobile(state)
    }
})(HeaderTitle);



// WEBPACK FOOTER //
// ./components/Header/Title/index.js